import React, { useCallback, useContext, useState } from 'react';
import { CloseSquareOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import AuditLogContext from '@totem/components/services/remoteAccess/auditLog/AuditLogContext';
import { debounce } from '@totem/utilities/debounce';

const DEBOUNCE_TIME = 300;

const AuditLogSearch = () => {
  const { onUserSearchChange, onAssigneeSearchChange, onRoleSearchChange } =
    useContext(AuditLogContext);

  const [userTerm, setUserTerm] = useState<string>('');
  const [assigneeTerm, setAssigneeTerm] = useState<string>('');
  const [roleTerm, setRoleTerm] = useState<string>('');

  const sendUserSearch = useCallback(
    debounce((val: string) => onUserSearchChange(val), DEBOUNCE_TIME),
    [],
  );

  const sendAssigneeSearch = useCallback(
    debounce((val: string) => onAssigneeSearchChange(val), DEBOUNCE_TIME),
    [],
  );

  const sendRoleSearch = useCallback(
    debounce((val: string) => onRoleSearchChange(val), DEBOUNCE_TIME),
    [],
  );

  const handleUserChange = (val: string) => {
    setUserTerm(val);

    sendUserSearch(val);
  };

  const handleAssigneeChange = (val: string) => {
    setAssigneeTerm(val);

    sendAssigneeSearch(val);
  };

  const handleRoleChange = (val: string) => {
    setRoleTerm(val);

    sendRoleSearch(val);
  };

  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: '280px' }}>
            <b>Role:</b>&nbsp;
            <Input
              placeholder="Search role"
              value={roleTerm}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                handleRoleChange(evt.target.value ?? '')
              }
            />
          </td>
          <td style={{ width: '32px' }}>
            <br />
            <CloseSquareOutlined onClick={() => handleRoleChange('')} />
          </td>
          <td style={{ width: '280px' }}>
            <b>Assignee:</b>&nbsp;
            <Input
              placeholder="Search assignee"
              value={assigneeTerm}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                handleAssigneeChange(evt.target.value ?? '')
              }
            />
          </td>
          <td style={{ width: '32px' }}>
            <br />
            <CloseSquareOutlined onClick={() => handleAssigneeChange('')} />
          </td>
          <td style={{ width: '280px' }}>
            <b>User:</b>&nbsp;
            <Input
              placeholder="Search user"
              value={userTerm}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                handleUserChange(evt.target.value ?? '')
              }
            />
          </td>
          <td style={{ width: '32px' }}>
            <br />
            <CloseSquareOutlined onClick={() => handleUserChange('')} />
          </td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  );
};

export default AuditLogSearch;
